import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resendSuccess, setResendSuccess] = useState('');
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const redirectTo = queryParams.get("redirectTo") || "/";

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setResendSuccess('');
  
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
  
    if (error) {
      if (error.message.includes('Email not confirmed')) {
        setError('Your email is not confirmed. Click below to resend confirmation.');
      } else {
        setError(error.message);
      }
    } else {
      navigate(redirectTo); // Redirect to original target or fallback to "/"
    }
  };
 

  const resendConfirmation = async () => {
    setResendSuccess('');
    setError('');

    const { error } = await supabase.auth.resend({
      type: 'signup',
      email,
    });

    if (error) {
      setError(error.message);
    } else {
      setResendSuccess('A new confirmation email has been sent. Check your inbox.');
    }
  };

  return (
    <>
      <div className="max-w-md mx-auto py-16">
        <h1 className="text-2xl font-bold text-center mb-6">Login</h1>
        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Email"
            className="w-full p-3 border border-gray-300 rounded-lg"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            className="w-full p-3 border border-gray-300 rounded-lg"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="text-red-500">{error}</p>}
          {error.includes('not confirmed') && (
            <button
              type="button"
              onClick={resendConfirmation}
              className="w-full bg-yellow-500 text-white p-3 rounded-lg mt-2"
            >
              Resend Confirmation Email
            </button>
          )}
          {resendSuccess && <p className="text-green-500">{resendSuccess}</p>}
          <button type="submit" className="w-full bg-teal-500 text-white p-3 rounded-lg">
            Login
          </button>
        </form>

        <p className="text-center mt-4">
          <Link to="/reset-password" className="text-teal-500 font-semibold">
            Forgot Password?
          </Link>
        </p>

        <p className="text-center mt-4">
          Don’t have an account?{' '}
          <Link to="/signup" className="text-teal-500 font-semibold">
            Sign up here
          </Link>
        </p>
      </div>
    </>
  );
};

export default Login;
